<script setup lang="ts">
defineProps<{ label: string }>();

const model = defineModel<boolean>({ required: true });
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-label="label"
    :aria-checked="model"
    class="relative h-7 w-12 shrink-0 cursor-pointer rounded-full transition-colors"
    :class="model ? 'bg-accent' : 'bg-filet'"
    @click="model = !model"
  >
    <i
      class="bg-carte absolute top-[3px] size-[22px] rounded-full shadow-[0_1px_2px_rgba(0,0,0,0.3)] transition-[left] motion-reduce:transition-none"
      :class="model ? 'left-[23px]' : 'left-[3px]'"
    ></i>
  </button>
</template>
